import { Actiontypes } from "./ActionType";

  export const Profile = (data) => {
    return {
        type: Actiontypes.PROFILE,
         payload: data,
    };
  };  

  export const News = (data) => {
    return {
        type: Actiontypes.NEWS,
         payload: data,
    };
  };  

 
  

 
  
  
  
  
  
  